import React from 'react';
import { Box, Breadcrumbs, Link, Typography } from '@mui/material';

const PageHeader = ({ title, overline, description, crumbs = [], left, right }) => {
  return (
    <Box sx={{ mb: 4, display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', width: '100%' }}>
      {left ? (
        <Box sx={{ position: 'absolute', left: 0, top: '50%', transform: 'translateY(-50%)', flexShrink: 0 }}>
          {left}
        </Box>
      ) : null}
      
      <Typography variant="h4" sx={{ fontWeight: 900, letterSpacing: -0.5, lineHeight: 1.1, textAlign: 'center' }}>
        {title}
      </Typography>

      {right ? (
        <Box sx={{ position: 'absolute', right: 0, top: '50%', transform: 'translateY(-50%)', flexShrink: 0 }}>
          {right}
        </Box>
      ) : null}
    </Box>
  );
};

export default PageHeader;

